import RoleUsersCard from "pages/projects/molecules/RoleUsersCard"
import { GetUsersInProjectProp } from "pages/project-component/types"
import DotCard from "pages/conversations/atoms/DotCard"
import LabelStatusBuild from "pages/project-component/molecules/LabelStatusBuild"
import { STATUS_BUILD } from "components/Status/types"
import { pushTo } from "helpers/history"
import { MENU_TAB_ACCESS_KEY } from "../address-book.type"
import { PATH } from "constants/path"

interface Props {
  build: {
    id: string
    name: string
    project_id: string
    project_name: string
    project_code: string
    code: string
    components: string[]
    status: string
    users: GetUsersInProjectProp[]
  }
  projectBuildIdActive: {
    setValue: (value: string) => void
    value: string
  }
}
export const ProjectBuildItemCard = (props: Props) => {
  const { build, projectBuildIdActive } = props

  const handleSelectProject = (buildId: string) => () => {
    if (projectBuildIdActive.value === buildId) return
    pushTo(PATH.accessKey, undefined, undefined, {
      tab: MENU_TAB_ACCESS_KEY.BUILD,
      projectBuildId: buildId,
    })
    projectBuildIdActive.setValue(buildId)
  }
  return (
    <div
      onClick={handleSelectProject(build.id)}
      key={build.id}
      className={`hover-project-card p-3 bg-white border border-[#e4e4e4] rounded-[6px] cursor-pointer flex flex-col gap-2 ${
        projectBuildIdActive.value === build.id ? "active-project-build" : ""
      }`}
    >
      <div className="flex items-center">
        <p
          className="text-14 leading-24 color-black-111111 font-semibold"
          style={{
            whiteSpace: "nowrap",
            color: "#111111",
          }}
        >
          {build.code}
        </p>
        <DotCard styleRoot={{ marginLeft: 4, marginRight: 4 }} />
        <LabelStatusBuild
          status={
            build.status ? (build.status as STATUS_BUILD) : STATUS_BUILD.DRAFT
          }
          rootStyle={{
            fontSize: 12,
            lineHeight: "18px",
          }}
        />
      </div>
      <div className="flex items-center">
        <p className="text-12 leading-18 color-gray-7a font-medium text-[#7a7a7a]">
          {build.project_code}:{` ${build.project_name}`}
        </p>
      </div>
      <div className="flex items-center flex-wrap">
        {build.components.length
          ? build.components.map((component, index) => (
              <div
                key={index}
                className="px-1 flex items-center mr-1 mb-1"
                style={{
                  background: "#F7F7F7",
                  border: "1px solid #E4E4E4",
                  borderRadius: 4,
                  height: 20,
                }}
              >
                <p
                  className="font-semibold"
                  style={{
                    fontSize: 10,
                    lineHeight: "14px",
                    color: "#7a7a7a",
                  }}
                >
                  {component}
                </p>
              </div>
            ))
          : null}
      </div>
      <RoleUsersCard data={build.users} max={3} />
    </div>
  )
}
